if (!customElements.get('bc-contact-reveal')) customElements.define('bc-contact-reveal', class extends HTMLElement {
  connectedCallback() {
    const details = this.querySelector('details');
    const reveal = () => {
      if (location.hash === '#ContactForm' || this.querySelector('.form-status,.form__message')) details.open = true;
    };
    details.open = false;
    reveal();
    this.onHash = reveal;
    window.addEventListener('hashchange', this.onHash);
  }
  disconnectedCallback() { window.removeEventListener('hashchange', this.onHash); }
});
